export default "https://cdn-static.gokick.com/assets/28dce4dd80241a45018c00057f67470c3fae89ba/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";